import { Component, EventEmitter, Input, Output } from '@angular/core';
import { APIService } from 'src/app/core/api/general.service';
import { Location } from 'src/app/core/models/itinerary.model';
import { IAirportByName } from 'src/app/core/models/models';

@Component({
  selector: 'app-search-location',
  templateUrl: './search-location.component.html'
})
export class SearchLocationComponent {
  @Input() selectedLocation: Location;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() errorMessage: string;
  @Input() submitted: boolean;
  @Input() disabled: boolean;

  @Output() chooseLocation = new EventEmitter<Location>();

  oldList: Location[];
  list: Location[];

  constructor(private apiService: APIService) {}

  onSearch(event: any) {
    if (event.term === '') {
      this.ChangeNewList();
      return;
    }

    if (event.term.length >= 2) {
      this.apiService.getAirportByName(event.term.toUpperCase()).subscribe((res) => {
        let result = this.transformLocations(res.body);

        if (result.length > 0) {
          this.list = [];
          this.list = result;
          this.oldList = result;

          let resultList = this.list.filter((x) => x.code.includes(event.term.toUpperCase()));

          if (resultList.length > 0) {
            this.list = resultList;
            this.oldList.forEach((obj) => {
              if (obj.code != event.term.toUpperCase()) {
                this.list.push(obj);
              }
            });
          } else {
            this.ChangeNewList();
          }
        }
      });
    }
  }

  ChangeNewList() {
    this.list = this.oldList;
  }

  onChangeLocation(selectedLocation: Location) {
    this.chooseLocation.emit(selectedLocation);
  }

  transformLocations(data: IAirportByName[]): Location[] {
    let locations: Location[];
    locations = data.map((airport: IAirportByName) => {
      const location: Location = {
        code: airport?.parameter?.iataCode,
        name: airport?.parameter?.city,
        airportName: airport?.parameter?.name,
        timeZone: airport?.parameter?.timeZone,
        country: airport?.parameter?.countryIsoCode,
        label:
          airport?.parameter?.iataCode +
          ' - ' +
          airport?.parameter?.city +
          ' - ' +
          airport?.parameter?.name
      };

      return location;
    });
    return locations;
  }
}
